import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import Head from "@/components/Head/index.vue";
import { defineComponent, reactive, ref, watch, nextTick } from "vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { useRoute, useRouter } from "vue-router";
import { ArrowRight } from "@element-plus/icons";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

export default defineComponent({
  //name: "Information",
  components: {
    Head: Head,
    ArrowRight: ArrowRight
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var route = useRoute();
    var router = useRouter();
    var field = route.query.field; // let defaultTime1 = [new Date(2000, 1, 1, new Date().getHours(), 0, 0)]
    // if(new Date().getMinutes()<30){
    //   defaultTime1 = [new Date(2000, 1, 1, new Date().getHours(), 0, 0)]
    // }else{
    //   defaultTime1 = [new Date(2000, 1, 1, new Date().getHours() + 1, 0, 0)]
    // }

    var Data = reactive({
      endDidabled: true,
      searchContent: "",
      value1: "",
      value2: "",
      form: {
        fieldId: field,
        name: "",
        applicantPhone: "",
        startTime: "",
        endTime: "",
        text: ""
      },
      timeData: {
        fieldId: field,
        time: getTime()
      },
      timeDatas: [{
        startTime: "",
        endTime: ""
      }],
      disTime: [],
      vialue: true,
      num: [],
      flagList: [],
      timeItems: [],
      flag: false,
      starts: false
    }); //计数

    for (var i = 0; i < 49; i++) {
      Data.num.push(i);
    }

    Data.num.map(function (i, d) {
      var val = i / 2 < 10 ? "0" + Math.floor(i / 2) : Math.floor(i / 2),
          val1 = Math.ceil(i % 2) == 1 ? "30" : "00";
      Data.timeItems.push(val + ":" + val1);
    });

    var contentPass = function contentPass(rule, value, callback) {
      console.log();

      if (Data.form.startTime == "") {
        callback(new Error("选择开始时间"));
      } else if (new Date(Data.form.startTime).getDate() == new Date().getDay() && Data.form.startTime.slice(11, 16).indexOf("00:00") != -1) {
        callback(new Error("选择正确的时间"));
      } else if (new Date(Data.form.startTime) < new Date()) {
        callback(new Error("开始时间小于当前时间"));
      } else if (Data.starts == true) {
        callback(new Error("该时间已有预定"));
      } else {
        callback();
      }
    };

    var contentPass1 = function contentPass1(rule, value, callback) {
      if (Data.form.endTime == "") {
        callback(new Error("选择结束时间"));
      } else if (new Date(Data.form.endTime) <= new Date(Data.form.startTime)) {
        callback(new Error("结束时间需大于开始时间"));
      } else if (Data.vialue == false) {
        callback(new Error("该时间已有预定"));
      } else {
        callback();
      }
    };

    var rules = {
      value1: [{
        required: true,
        validator: contentPass,
        trigger: "change"
      }],
      value2: [{
        required: true,
        validator: contentPass1,
        trigger: "change"
      }],
      applicantPhone: [{
        required: true,
        message: "请输入手机号",
        trigger: "blur"
      }, {
        pattern: /^1[0-9]{10}$/,
        message: "请输入11位手机号码",
        trigger: "blur"
      }],
      name: [{
        required: true,
        message: "请输入姓名",
        trigger: "blur"
      }],
      text: [{
        required: true,
        message: "请填写备注",
        trigger: "blur"
      }]
    }; //获取单个场地时间

    function getFieldTime() {
      return _getFieldTime.apply(this, arguments);
    }

    function _getFieldTime() {
      _getFieldTime = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$globalProperti, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getFieldTime"](Data.timeData);

              case 2:
                _yield$globalProperti = _context3.sent;
                data = _yield$globalProperti.data;
                Data.timeDatas = [];
                data.forEach(function (item) {
                  Data.timeDatas.push({
                    startTime: item.startTime,
                    endTime: item.endTime
                  });
                });
                Data.timeDatas.forEach(function (item) {
                  Data.disTime.push(new Date(item.startTime).getHours());
                  Data.disTime.push(new Date(item.endTime).getHours());
                });

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _getFieldTime.apply(this, arguments);
    }

    getFieldTime();

    function getTime() {
      var date = new Date(),
          year = date.getFullYear(),
          month = date.getMonth() + 1,
          day = date.getDate();
      var months = month < 10 ? "0" + month : month;
      var timer = year + "-" + months + "-" + day;
      return timer;
    } //提交


    var ruleForms = ref();

    function submit() {
      return _submit.apply(this, arguments);
    }

    function _submit() {
      _submit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                ruleForms.value && ruleForms.value["validate"]( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(valid) {
                    var _yield$globalProperti2, code;

                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            if (!valid) {
                              _context4.next = 6;
                              break;
                            }

                            _context4.next = 3;
                            return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["addField"](Data.form);

                          case 3:
                            _yield$globalProperti2 = _context4.sent;
                            code = _yield$globalProperti2.code;

                            if (code == 0) {
                              ElMessage.success("预约成功");
                              router.back();
                            } else {
                              ElMessage.error("请勿重复预约");
                            }

                          case 6:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));

                  return function (_x3) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
      return _submit.apply(this, arguments);
    }

    var makeRange = function makeRange(start, end) {
      var result = [];

      for (var _i = start; _i <= end; _i++) {
        result.push(_i);
      }

      return result;
    };

    var disabledHours = function disabledHours() {
      if (new Date(Data.value1).getFullYear() == new Date().getFullYear() && new Date(Data.value1).getMonth() == new Date().getMonth() && new Date(Data.value1).getDate() == new Date().getDate()) {
        var conTime = new Date().getHours();
        var conmin = new Date().getMinutes();
        var result = [];

        if (conmin < 30) {
          for (var _i2 = 0; _i2 < conTime; _i2++) {
            result.push(_i2);
          }
        } else {
          for (var _i3 = 0; _i3 <= conTime; _i3++) {
            result.push(_i3);
          }
        }

        var indexNum = [];
        Data.timeDatas.forEach(function (item) {
          Data.num.forEach(function (item1, index) {
            if (new Date(item.startTime).getHours() == item1 && new Date(item.startTime).getMinutes() != 30) {
              indexNum.push(index);
            } else if (new Date(item.startTime).getHours() == item1 && new Date(item.startTime).getMinutes() == 30) {
              indexNum.push(index + 1);
            }

            if (new Date(item.endTime).getHours() == item1) {
              indexNum.push(index);
            } else if (new Date(item.endTime).getHours() == item1 && new Date(item.startTime).getMinutes() == 30) {
              indexNum.push(index - 1);
            }
          });
          indexNum = Data.num.slice(indexNum[0], indexNum[1]);
          indexNum.forEach(function (item) {
            result.push(item);
          });
        });
        Data.flagList = result;
        return result;
      } else {
        var _result = [];
        var _indexNum = [];
        Data.timeDatas.forEach(function (item) {
          Data.num.forEach(function (item1, index) {
            if (new Date(item.startTime).getHours() == item1 && new Date(item.endTime).getMinutes() != 30) {
              _indexNum.push(index);
            } else if (new Date(item.startTime).getHours() == item1 && new Date(item.startTime).getMinutes() == 30) {
              _indexNum.push(index + 1);
            }

            if (new Date(item.endTime).getHours() == item1) {
              _indexNum.push(index);
            } else if (new Date(item.endTime).getHours() == item1 && new Date(item.startTime).getMinutes() == 30) {
              _indexNum.push(index - 1);
            }
          });
          _indexNum = Data.num.slice(_indexNum[0], _indexNum[1]);

          _indexNum.forEach(function (item) {
            _result.push(item);
          });
        });
        Data.flagList = _result;
        return _result;
      }
    };

    var disabledMinutes = function disabledMinutes(hour) {
      // let conTime = new Date().getHours();
      // let conmin = new Date().getMinutes();
      Data.timeDatas.forEach(function (item) {
        if (hour == new Date(item.startTime).getHours()) {
          if (new Date(item.startTime).getMinutes() == 30) {
            Data.flag = true;
          } else {
            Data.flag = false;
          }
        }
      });

      if (Data.flag == false) {
        return makeRange(1, 29).concat(makeRange(31, 59));
      } else {
        return makeRange(0, 29).concat(makeRange(31, 59));
      }
    }; //时间


    function disabledDateFun(time) {
      return time.getTime() < new Date().getTime() - 8.64e7;
    }

    function disabledEndfDate(time) {
      return time.getDate() != new Date(Data.value1).getDate();
    } //返回


    function backfun() {
      router.back();
    } // 禁止时间选择组件内部手动写入时间


    function timeEditable() {
      nextTick(function () {
        var els = document.querySelectorAll('.el-date-picker__editor-wrap input');

        for (var i = 0; i <= els.length - 1; i++) {
          els[i].setAttribute('readonly', 'readonly');
        }
      });
    } //选择开始时间
    // function handleStartTime(val) {
    //   Data.value1 = val;
    //   Data.endDidabled = false;
    // }


    watch(function () {
      return Data.value1;
    }, /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(val) {
        var start, p, startDate;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                start = new Date(val);

                p = function p(s) {
                  return s < 10 ? "0" + s : s;
                };

                startDate = start.getFullYear() + "-" + p(start.getMonth() + 1) + "-" + p(start.getDate()) + " " + p(start.getHours()) + ":" + p(start.getMinutes()) + ":" + p(start.getSeconds());

                if (startDate.slice(0, 10) != Data.form.startTime.slice(0, 10)) {
                  Data.timeData.time = String(startDate.slice(0, 10));
                  getFieldTime();
                }

                Data.form.startTime = startDate;
                console.log(Data.form.startTime, 1111);
                Data.timeDatas.forEach(function (item) {
                  if (Data.form.startTime == item.startTime) {
                    Data.starts = true;
                  } else {
                    Data.starts = false;
                  }
                });
                Data.endDidabled = false;

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    watch(function () {
      return Data.value2;
    }, /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(val) {
        var end, p, endDate;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                end = new Date(val);

                p = function p(s) {
                  return s < 10 ? "0" + s : s;
                };

                endDate = end.getFullYear() + "-" + p(end.getMonth() + 1) + "-" + p(end.getDate()) + " " + p(end.getHours()) + ":" + p(end.getMinutes()) + ":" + p(end.getSeconds());
                Data.form.endTime = endDate;
                Data.flagList.forEach(function (item1) {
                  Data.num.slice(new Date(Data.form.startTime).getHours(), new Date(Data.form.endTime).getHours()).forEach(function (item2) {
                    if (item1 == item2) {
                      Data.vialue = false;
                    } else {
                      Data.vialue = true;
                    }
                  });
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    return {
      submit: submit,
      Data: Data,
      backfun: backfun,
      getFieldTime: getFieldTime,
      disabledEndfDate: disabledEndfDate,
      rules: rules,
      ruleForms: ruleForms,
      disabledDateFun: disabledDateFun,
      disabledHours: disabledHours,
      makeRange: makeRange,
      disabledMinutes: disabledMinutes,
      timeEditable: timeEditable
    };
  }
});